import { Transition } from '@headlessui/react';
import { useState } from 'react';

import MarkdownIcon from '~/components/Icons/MarkdownIcon';

const Tooltip = ({ children }: any) => {
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  return (
    <div className="relative inline-block">
      <div onMouseEnter={() => setTooltipVisible(true)} onMouseLeave={() => setTooltipVisible(false)}>
        {children}
      </div>

      <Transition
        show={isTooltipVisible}
        enter="transition-opacity duration-150"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="absolute right-0 z-10 mt-2 flex flex-col space-y-2 rounded bg-gray-800 px-2 py-1 text-sm text-white">
          <p className="whitespace-nowrap">Simple markdown supported: </p>
          <ul className="list-disc pl-4">
            <li>*italics*</li>
            <li>**bold**</li>
            <li>***bold italics***</li>
            <li>~~strike through~~</li>
            <li>==highlight==</li>
            <li>1. numbered list</li>
          </ul>
        </div>
      </Transition>
    </div>
  );
};

const MarkDownHelperText = () => {
  return (
    <div className="space-y-2 text-sm">
      <Tooltip>
        <MarkdownIcon />
      </Tooltip>
    </div>
  );
};

export default MarkDownHelperText;
